/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maximumpricemustbegreaterthanminimumprice7Inputs */

const en_maximumpricemustbegreaterthanminimumprice7 = /** @type {(inputs: Maximumpricemustbegreaterthanminimumprice7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum price must be greater than minimum price`)
};

const de_maximumpricemustbegreaterthanminimumprice7 = /** @type {(inputs: Maximumpricemustbegreaterthanminimumprice7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Höchstpreis muss größer als der Mindestpreis sein`)
};

/**
* | output |
* | --- |
* | "Maximum price must be greater than minimum price" |
*
* @param {Maximumpricemustbegreaterthanminimumprice7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const maximumpricemustbegreaterthanminimumprice7 = /** @type {((inputs?: Maximumpricemustbegreaterthanminimumprice7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maximumpricemustbegreaterthanminimumprice7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_maximumpricemustbegreaterthanminimumprice7(inputs)
	return de_maximumpricemustbegreaterthanminimumprice7(inputs)
});
export { maximumpricemustbegreaterthanminimumprice7 as "maximumPriceMustBeGreaterThanMinimumPrice" }